import { render, staticRenderFns } from "./GroupsFilterByUser.vue?vue&type=template&id=1d785822&scoped=true&"
import script from "./GroupsFilterByUser.vue?vue&type=script&lang=js&"
export * from "./GroupsFilterByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d785822",
  null
  
)

export default component.exports